import { SessionProfiloInterface } from '../interfaces/SessionProfilo';

interface BluBookingConfigInterface {
  getClient?: any;
  underline: string;
  underlineHour: string;
  isBluBookingActive: boolean;
  firstLoad: boolean;
  sessionProfilo: SessionProfiloInterface;
  selezioneCliente?: (codiceCliente: string) => string;
  token?: string;
  url?: string;
  darkMode?: string;
  maxBookingValue?: number;
  focusWeb?: boolean;
  focus10?: boolean;
  focusCloud?: boolean;
  manageOpenSearch: boolean;
  alreadyLoaded: {
    default: boolean;
    studio: boolean;
    personal: boolean;
    user: boolean;
  };
  hasInitialScrolled: {
    default: boolean;
    studio: boolean;
    personal: boolean;
    user: boolean;
  };
  programmaticScrollBlocked: {
    default: boolean;
    studio: boolean;
    personal: boolean;
    user: boolean;
  };
  lastScrollPosition: {
    default: number;
    studio: number;
    personal: number;
    user: number;
  };
}

const defaultConfig: BluBookingConfigInterface = {
  token: '',
  url: '',
  darkMode: 'light',
  maxBookingValue: 30,
  focusWeb: false,
  focus10: false,
  focusCloud: false,
  underline: '',
  underlineHour: '07:00',
  isBluBookingActive: false,
  firstLoad: false,
  sessionProfilo: {
    agendaInserimento: true,
    agendaModifica: true,
    agendaCancellazione: true,
    turniInserimento: true,
    turniModifica: true,
    turniCancellazione: true,
  },
  manageOpenSearch: false,
  alreadyLoaded: {
    default: false,
    studio: false,
    personal: false,
    user: false,
  },
  hasInitialScrolled: {
    default: false,
    studio: false,
    personal: false,
    user: false,
  },
  programmaticScrollBlocked: {
    default: false,
    studio: false,
    personal: false,
    user: false,
  },
  lastScrollPosition: {
    default: 0,
    studio: 0,
    personal: 0,
    user: 0,
  },
};

let bluBookingConfig: BluBookingConfigInterface = {
  ...defaultConfig,
};

export const getConfig = () => bluBookingConfig;
export const setConfig = (
  key: keyof BluBookingConfigInterface,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any | undefined
) => {
  bluBookingConfig = {
    ...bluBookingConfig,
    [key]: value ?? undefined,
  };
};

export const resetConfig = () => {
  bluBookingConfig = {
    ...defaultConfig,
  };
};
